module.exports = __webpack_public_path__ + "img/32-m-7-4-k-uhd-smart-monitor-1-copy@2x.9d4d375b.png";